import apiClient from "./apiClient";

export function getAllPermissionsRequest() {
  return apiClient.get("/permissions/all");
}
